import type React from "react"
import { useTranslation } from "react-i18next"

import { FormSelectField } from "@/nzds/forms/form-select-field/form-select-field"
import { useBillUsageUnits } from "@/services/bill/use-bill-usage-units"
import { buildStringSelectOptions } from "@/utils/build-string-select-options"
import { EMPTY_DATA_PLACEHOLDER } from "@/utils/constants"

interface UsageUnitFieldProps {
  /** The record's stored unit, kept as an option even when the list lacks it */
  currentValue?: string | null
  disabled?: boolean
  /** A required field has no empty option */
  required?: boolean
}

/** The usage unit select of a form with a `usageUnit` field; it loads its own options */
export const UsageUnitField: React.FC<UsageUnitFieldProps> = ({
  currentValue,
  disabled = false,
  required = false,
}) => {
  const { t } = useTranslation("common")
  const { usageUnitsData, usageUnitsIsFetching } = useBillUsageUnits()

  return (
    <FormSelectField
      disabled={disabled}
      label={t("editBill.usageUnitLabel")}
      name="usageUnit"
      options={buildStringSelectOptions(
        usageUnitsData,
        currentValue,
        required ? undefined : { label: EMPTY_DATA_PLACEHOLDER, value: "" }
      )}
      // A disabled field is dropped from the submission, so loading must not disable it
      readOnly={usageUnitsIsFetching}
      required={required}
      variant="stacked"
    />
  )
}
